<template>
  <div class="index">
      

      <van-skeleton style="padding:15px;height:100vh" title-width="40%" title avatar :row="8" :row-width="rowWidth" :loading="showUiLoading">
          <img src="../../assets/fb.png" @click="toRelease" class="releaseImg" />
          <div class="top_info">
            <img class="flurImg" :src="othersUserInfo && othersUserInfo.background" />
            <div class="mask_f"></div>
            <div class="release" v-if="!shareOpen" @click="toPersonalCenter">
                <img src="../../assets/grzx.png" style="width:1.36rem;;height:1.36rem;" alt="" />
                <div style="padding-left:3px;font-size:1rem">个人中心</div>
            </div>
            <div class="release" v-else @click="wezhuye">
                <img :src="userinfoMe && userinfoMe.headimgurl" style="width:1.36rem;;height:1.36rem;border-radius:50%;" />
                <div style="padding-left:3px;font-size:1rem">我的主页</div>
            </div>
            <div class="top_i_m">
              <div class="headerorname">
                <div>
                  <img class="header" :src="othersUserInfo && othersUserInfo.headimgurl" alt="">
                  <div style="padding-top:.3rem">uid: {{othersUserInfo && othersUserInfo.id}}</div>
                </div>
                
                <div class="username f1">{{othersUserInfo && othersUserInfo.nickname}}</div>
              </div>
              <div class="infobrif f2">{{othersUserInfo && othersUserInfo.info}}</div>
              <div class="data_info" style="width:12rem">
                <div style="text-align:center" @click="toWePath('/focusOn')">
                    <div style="font-size:1.1rem;font-weight:500">{{othersUserInfo && othersUserInfo.follow_num}}</div>
                    <div>关注</div>
                </div>
                <div style="text-align:center" @click="toWePath('/Fans')">
                    <div style="font-size:1.1rem;font-weight:500">{{othersUserInfo && othersUserInfo.fans_num}}</div>
                    <div>粉丝</div>
                </div>
                <div style="text-align:center">
                    <div style="font-size:1.1rem;font-weight:500">{{mainListInfo && mainListInfo.count}}</div>
                    <div>作品</div>
                </div>
              </div>
              <div class="data_info2 data_info" style="width:100%;justify-content:initial">
                <div class="btn" @click="showSharePtype(1)">分享</div>
                <div style="background:#4B8FF8;margin-left:1.2rem" class="btn" v-if="shareOpen" @click="takeThePass(mainListInfo && mainListInfo.is_follow)">{{mainListInfo && mainListInfo.is_follow == 1?'取消关注':'关注'}}</div>
                <div style="margin-left:1.2rem" class="btn" v-if="!shareOpen" @click="toPath('/HomepageSettings')">编辑资料</div>
                <div style="margin-left:1.2rem" class="btn" @click="sort">{{order==1?'倒序':'正序'}}</div>
              </div>
              <!-- <div class="btn bmkuoce" @click="todashang(1)">打赏收益</div> -->
            </div>
            
        </div>
        <div class="mian">
            <!-- 专辑列表 -->
            <div class="ceeex">
                <div class="main_zj">
                    <div @click="setnav(i,l)"  :class="`everyAlbum ${albumIndex == l?'albumActive':''}`" v-for="(i,l) in albumArr && albumArr" :key="l" >
                        <img :src="i.image" class="flurImg" style="height:auto" />
                        <div class="mask_everyAlbum"></div>
                        <div class="everyAlbumText">{{i.title}}</div>
                    </div>
                </div>
            </div>
            <div class="albumcard"  @click="toEditAlbum" v-if="albumIndex != 0">
              <div style="display:flex;align-items:center">
                <img :src="albumInfo && albumInfo.image" style="width: 2.71rem;height: 2.71rem;border-radius:4px;" />
                <div style="padding-left:.71rem;">
                  <div style="font-size:1rem;color:#333">{{albumInfo && albumInfo.title}}</div>
                  <div style="font-size:.86rem;color:#999;padding-top:3px;">
                    共{{shareOpen?albumInfo && albumInfo.voice_real_num:albumInfo && albumInfo.voice_num}}个音频</div>
                </div>
              </div>

              <img src="../../assets/right_c.png" style="width:1.21rem;height:1.21rem;" />
            </div>
            <!-- 音频列表 -->
            
            <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onPagination"
            >
              
                <div v-for="(item,k) in voiceArr && voiceArr" :key="k" @click="toAudioPlayer(item)">
                    <div class="main_list" >
                        <div class="zhidingclass" v-if="item.is_top == 1">置顶</div>
                        <div style="display: flex;align-items: center;">
                            <img class="ypimg" :src="`${item.image == '/images/wt.png'?'https://bgy-speechshare.oss-cn-beijing.aliyuncs.com/images/2021/04/07/41495-1617766910423':item.image}`" />
                            <div class="ypinfo">
                                <div class="f2 title"><span  :style="`color:${item.is_examine==0?'#0174B4':'red'};padding-right:5px`">{{item.is_examine==0?'审核中':item.is_examine==1||item.is_examine==3?'未通过':''}}</span>{{item.title}}</div>
                                <div class="bottom_info">
                                    <div>{{item.addtime}}</div>
                                </div>
                            </div>
                        </div> 
                        <div v-if="!shareOpen" style="line-height:6.21rem;text-align:right;color:#4B8FF8;padding-left:1.71rem" @click.stop="operate(item)">操作</div>
                        
                    </div>
                    <div>
                        <div v-if="item.is_examine == 1||item.is_examine==3" style="padding-left:15px;color:red">未通过原因:{{item.examine_remark}}</div>
                    </div>
                    
                </div>
                
            </van-list>
        </div>
      </van-skeleton>
      

      <!-- 操作面板 -->
      <van-action-sheet v-model="showPanecl" title="操作">
          <div style="padding: 15px;padding-top:0">
              <div class="lloeididt" @click="showSharePtype(2)">
                  <img src="../../assets/zufa.png" style="width:20px;height:20px;" />
                  <div style="padding-left:11px;color:#333333;font-size:16px;">分享</div>
              </div>
              <div class="lloeididt" @click="operationStick(voiceInfoAlone && voiceInfoAlone.is_top == 1?0 : 1)">
                  <img src="../../assets/zd.png" style="width:20px;height:20px;" />
                  <div style="padding-left:11px;color:#333333;font-size:16px;">{{voiceInfoAlone && voiceInfoAlone.is_top == 1?'取消置顶':'置顶'}}</div>
              </div>
              <div class="lloeididt" @click="edit">
                  <img src="../../assets/bi.png" style="width:20px;height:20px;" />
                  <div style="padding-left:11px;color:#333333;font-size:16px;">编辑</div>
              </div>
              <div class="lloeididt" @click="deletec">
                  <img src="../../assets/dede.png" style="width:20px;height:20px;" />
                  <div style="padding-left:11px;color:#333333;font-size:16px;">删除</div>
              </div>
          </div>
          
      </van-action-sheet>
      <!-- 分享面板 -->
      <van-share-sheet
        v-model="showShare"
        title="立即分享给好友"
        :options="shareIndex == 1?shareOptionsindex: shareOptions"
        @select="shareOnSelect"
      />
      <!--  -->
      <!-- 海报 -->
      <van-overlay z-index="1888" duration="0" :show="showCanvas" @click="showCanvas = false">

        <div class="wrapper" @click.stop>
          
          <div class="centerMain" >
            <!-- <img src="../../assets/closexsad.png" class="closecanvas" @click="showCanvas = false" style="width:1.87rem;height:1.87rem;" alt=""> -->
            <img v-if="x" :src="x" style="width: 18rem;height: 27.75rem;" alt="">
            <div v-else class="canvas_img" id="mycanvas">
              <!-- <div class="top_canvasImg" :style="`background-image:url(${shareInfo && shareInfo.poster? shareInfo && shareInfo.poster + '?'+randomNumber: 'https://speapp.zipaicefuqi.com/static/admin/images/shares.jpg?' + randomNumber})`"></div> -->
              <img class="top_canvasImg" style="display:block"  :src="`${shareInfo && shareInfo.poster? shareInfo && shareInfo.poster + '?time='+timestamp: 'https://bgy-speechshare-v2.oss-cn-beijing.aliyuncs.com/xcximg/2021/08/20/xcx-15474-1629431557034.png?time=' + timestamp}`" crossorigin="anonymous" />

              <div class="main_cx">
                <div class="img_userinfo">
                  <img class="img_userinfo_o" :src="`${shareInfo && shareInfo.image}?time=${timestamp}`" alt="" crossorigin="anonymous">
                  <div>
                    <div class="title_opx">{{shareInfo && shareInfo.title}}</div>
                    <div class="h_n_m" v-if="shareIndex == 2">
                        <img class="header_canvas" :src="`${shareInfo && shareInfo.headimgurl}?time=${timestamp}`" alt="" crossorigin="anonymous">
                        <div class="f1 name_canvas">{{shareInfo && shareInfo.nickname}}</div>
                    </div>
                  </div>
                </div>
                <div style="margin-top:1.5rem;display:flex;align-items:center">
                  
                  <img class="code_canvas" :src="shareInfo && shareInfo.voiceCodeImgUrl + '?time'+timestamp" alt="" crossorigin="anonymous">
                  <div style="color:#666;padding-left:1.8rem">
                    <div>识别二维码</div>
                    <div>进入{{shareIndex == 1?'主页':'该作品'}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="saveCarme" >长按图片保存到相册</div>
            <div class="saveCarme" style="background:#F6BE5E" @click="closecanvas">关闭</div>
          </div>
        </div>
        
      </van-overlay>
      <div class="mask_share23" v-if="showshareMask" @click=" showshareMask = false">
          <img src="../../assets/jjt.png" class="shareimg" alt="">
          <div class="sharebtnxdd">点击右上角进行分享</div>
      </div>
      <!-- <van-overlay :show="showb" z-index="9999">
        <div class="wrapper" @click.stop>
          <div style="text-align:center">
            <img style="width:15rem;height:15rem" :src="voiceCodeImgUrlxx" alt="">
            <div style="padding-top:1rem;color:#fff">功能迁移，长按识别上方小程序码进行查看</div>
          </div>
          
        </div>
      </van-overlay> -->
      <!-- <router-view :key="key" /> -->
  </div>
</template>

<script>
import { Toast,Dialog  } from 'vant'
import Vue from 'vue';
import flvjs from 'flv.js';
import html2canvas from "html2canvas"
// import s from 'Streamedian'
Vue.use(Toast,Dialog );
export default {
  name: 'index',
  data () {
    return {
      showb: true,
      showUiLoading: true,//是否展示本页内容
      showshareMask: false,
      loading: false, //分页的加载状态
      finished: false, // 分页是否完成
      rowWidth: ['100%','70%','80%','80%','40%','20%',],
      showPanecl: false,
      othersUid: 0,//作者uid
      shareOpen: false, //是否是自己的主页 false-自己打开 true- 打开别人的主页
      page: 0,//分页页数
      othersUserInfo: null,//作者信息
      userInfo: null, //浏览者信息
      voiceArr: [],//作者音频列表
      mainListInfo: 0,//列表接口信息
      albumArr: [],//专辑列表
      albumIndex: 0,//专辑索引
      albumInfo: null, //选中的专辑信息
      voiceInfoAlone: null, //操作选中的音频信息
      showCanvas: false,//分享canvas面板
      showShare: false,//分享面板显示状态
      shareOptions: [{ name: '朋友圈', icon: 'wechat-moments' },],
      shareOptionsindex: [{ name: '微信好友', icon: 'wechat' },{ name: '朋友圈', icon: 'wechat-moments' },],
      shareInfo: null,//分享信息 主页或者单个音频
      shareIndex: 1,//分享索引 1主页分享 2单个音频分享
      randomNumber: '85964120358',
      x: '',
      timestamp: '',
      userinfoMe: null,
      order: 1,
      voiceCodeImgUrlxx: ''
    }
  },
  created() {
      
    
    
  },
  mounted() {
    // if (flvjs.isSupported()) {
    //         var videoElement = document.getElementById('videoElement');
    //         this.flvPlayer = flvjs.createPlayer({
    //                 type: "flv",
    //                 isLive: true,
    //                 fluid: true,
    //                 stashInitialSize: 128,// 减少首桢显示等待时长
    //                 url: 'http://127.0.0.1:8000/live/abc.flv'
    //           },{
    //                 enableStashBuffer: false,
    //                 fixAudioTimestampGap:false,
    //                 isLive: true
    //           });
    //         this.flvPlayer.attachMediaElement(videoElement);
    //         this.flvPlayer.load();
    //         this.flvPlayer.play();
    //   }
    // if (window.Streamedian) {
    //     // var p = Streamedian.player('test_video', {socket: "ws://45.32.210.71/ws/"})
    //     var p = Streamedian.player('test_video', {socket: "wss://streamedian.com/ws/"})
    // }
    if( !window.localStorage.getItem('uid')){
      return
    }
    console.log(this.$route.query,'index.js')
    //获取作者ID，分享此页面携带作者id，打开授权完成跳转到此页面并携带缓存的id页面

    let y = this.$route.query //获取url id参数
    if(y.id){
      //从授权页面跳转过来
      this.othersUid = this.$route.query.id
      if(this.$route.query.id == window.localStorage.getItem('uid')){
        //是作者本人
        this.shareOpen = false
      }else{
        this.shareOpen = true
      }
      this.showUiLoading = false
    }else{
      //没有携带id参数 有缓存uid，显示uid本人信息
      this.othersUid = window.localStorage.getItem('uid')
      this.showUiLoading = false
      this.shareOpen = false
    }
    console.log(this.$route.query.id)
    //获取浏览用户的个人信息 - auth页面授权会获取到用户信息 并缓存
    // this.userInfo = window.localStorage.getItem('PersonalInformation')
    this.getAlbum()
    // this.getIndexList(1)
    this.getUser()
    this.timestamp = Date.parse(new Date());
    this.userinfoMe = JSON.parse(window.localStorage.getItem('userInfoMe'))
    
  },  
  methods: {
    closecanvas() {
      this.showCanvas = false
      this.x = ''
    },
    savePhoto() {
      let targetDom = document.getElementById("mycanvas");
      const obj = {
          backgroundColor: '#ffffff',
          useCORS:true,
          allowTaint: false,
          taintTest:false,
          scale: 2,
          dpi: 150,
          width: targetDom.offsetWidth - 2
      }
      html2canvas(document.getElementById("mycanvas"),obj).then(canvas=> {
          Toast.clear()
          // console.log(canvas.toDataURL("image/png"))
          this.x = canvas.toDataURL("image/png")
          // this.downloadFileByBase64(canvas.toDataURL("image/png"))
      });
    },
    downloadFileByBase64(base64,name){
        var myBlob = this.dataURLtoBlob(base64)
        var myUrl = URL.createObjectURL(myBlob)
        
        console.log(this.x)
        // this.downloadFile(myUrl,name)
    },
    downloadFile(url,name='123456y'){
        var a = document.createElement("a")
          name = '123456yy' + Date.parse(new Date())
        a.setAttribute("href",url)
        a.setAttribute("download",name)
        a.setAttribute("target","_blank")
        let clickEvent = document.createEvent("MouseEvents");
        clickEvent.initEvent("click", true, true);  
        a.dispatchEvent(clickEvent);
    },
    dataURLtoBlob(dataurl) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    },
    getShareCode(v,cb) {
      const obj = {
        voice_uid: this.shareOpen? this.othersUserInfo.id: window.localStorage.getItem('uid'),
        share_uid: this.shareOpen?  this.othersUserInfo.id: window.localStorage.getItem('uid'),
        vid: this.shareIndex == 2? this.voiceInfoAlone.id: 0
      }
      this.$aGet('api/voice/usercode',obj ).then((res) => {
        // this.voiceCodeImgUrlxx = res.data.data
        cb && cb(res.data.data)

      })
    },
    toPersonalCenter() {
      this.$router.push({path:'/PersonalCenter',query:{}});
    },
    showSharePtype(y) {
      if(y == 2){
        if (this.voiceInfoAlone.is_examine == 0 || this.voiceInfoAlone.is_examine == 1|| this.voiceInfoAlone.is_examine == 3){
          Toast('审核中和未通过审核的作品无法分享，请规范作品内容',2000)
          return
        }
      }
      this.showShare = true
      this.shareIndex = y
      if(y == 2) {
        this.showPanecl = false
        
        this.getShareCode('api/voice/voicecode',(v=>{
          if(this.voiceInfoAlone.title.length >= 14){
            let y = this.voiceInfoAlone.title.substring(0,14)
            this.$set(this.voiceInfoAlone,'title',y + '...')
          }
          if(this.othersUserInfo.nickname.length >= 5){
            let y = this.othersUserInfo.nickname.substring(0,5)
            this.$set(this.othersUserInfo,'nickname',y + '...')
          }
          const obj = {
            title: this.voiceInfoAlone.title,
            image: this.voiceInfoAlone.image == '/images/wt.png'? 'https://bgy-speechshare.oss-cn-beijing.aliyuncs.com/images/2021/04/07/41495-1617766910423?84563210':this.voiceInfoAlone.image ,
            poster: this.othersUserInfo.poster,
            nickname: this.othersUserInfo.nickname,
            headimgurl: this.othersUserInfo.headimgurl,
            voiceCodeImgUrl: v
          }
          this.shareInfo = obj
          
        }))
        
      }else{
        
        this.getShareCode('api/voice/usercode',(v=>{
          if(this.othersUserInfo.nickname.length >= 14){
            let y = this.othersUserInfo.nickname.substring(0,14)
            
            this.$set(this.othersUserInfo,'nickname',y + '...')
            console.log(this.othersUserInfo.nickname,y)
          }
          const obj = {
            title: this.othersUserInfo.nickname,
            image: this.othersUserInfo.headimgurl,
            poster: this.othersUserInfo.poster,
            voiceCodeImgUrl: v
          }
          this.shareInfo = obj
          
        }))
      }
    },
    toRelease() {
      this.$router.push({path:'/release',query:{ id: 0,type: 2 }});
    },
    shareOnSelect(y) {
      this.showShare = false
      if(y.name == '朋友圈'){
        this.showCanvas = true
        setTimeout(()=>{
          Toast.loading({
            message: '',
            forbidClick: true,
            duration: 0,
            className: 'cnavasToast'
          });
          
          setTimeout(()=>{
            this.savePhoto()
          },1000)
        },100)
        
      }else{
        this.showshareMask = true
      }
    },
    wezhuye() {
      this.othersUid = window.localStorage.getItem('uid')
      this.page = 1
      this.voiceArr = []
      this.shareOpen = false
      this.getAlbum()
      this.getIndexList(1)
      this.$router.push({path:'/index',query:{ id: window.localStorage.getItem('uid') }});
    },
    getUser() {
      this.$aGet('api/user/user',{openid: window.localStorage.getItem('openid')} ).then((res) => {
        // window.localStorage.setItem('uid',res.data.data.id)
        // window.localStorage.setItem('openid',res.data.data.openid)
        // window.localStorage.setItem('unionid',res.data.data.unionid)
        window.localStorage.setItem('userInfoMe',JSON.stringify(res.data.data))
      })
    },
    sort() {
      
      if(this.order == 1)this.order = 2
      else this.order = 1

      this.page = 1
      this.voiceArr = []
      this.loading = false;
      this.finished = false;
      this.getIndexList(1)
    },
    getIndexList(page) {
      // 获取作者的音频信息及用户信息
      // Toast.loading({
      //   message: '加载中...',
      //   forbidClick: true,
      //   duration: 0
      // });
      const obj = {
        page,
        is_share: this.shareOpen ? 1 :0,
        order: this.order,
        voice_uid: this.othersUid //作者UID
      }
      this.$aGet('api/voice/voiceList',obj ).then((res) => {
          Toast.clear()
          if (res.data.code == 0 || res.data.code == 2) {
              Dialog.alert({
                  title: '提示',
                  message: res.data.msg,
              }).then(() => {});
              return
          }
          
          this.othersUserInfo = res.data.data.user
          // this.getShareCode()
          this.mainListInfo = res.data.data
          this.$wx.ready(()=>{
            let shareData = {
              imgUrl: this.othersUserInfo.headimgurl,
              link: `${this.$store.state.url}#${
                this.$route.path
              }?id=${this.othersUserInfo.id}&fid=${window.localStorage.getItem('uid')}`,
              desc: this.othersUserInfo.info,
              title: this.othersUserInfo.nickname ,
              success: function() {}
            };
            this.$wx.onMenuShareAppMessage(shareData);
          })
          this.loading = false;
          // this.showUiLoading = false
          if(res.data.data.data.length != 0){
              res.data.data.data.forEach((v,l)=>{
                  res.data.data.data[l].addtime = this.timeStampConversions(res.data.data.data[l].addtime)
              })
              this.voiceArr = this.voiceArr.length == 0?res.data.data.data:[...this.voiceArr,...res.data.data.data]
          }else{
              this.finished = true;
              this.voiceArr = this.voiceArr
          }
      }).catch(err=>{
          
      })
    },
    todashang() {
      this.$router.push({path:'/rewardList',query:{  }});
    },
    toPath(path) {
        this.$router.push({path:path,query:{ }});
    },
    getAlbum() {
      const obj = {
        uid: this.shareOpen ? this.othersUid : window.localStorage.getItem('uid'),
        user_id: window.localStorage.getItem('uid'),
        page: 1
      }
      this.$aGet('api/album/album_my',obj ).then((res) => {
        const albumAllAudio = {
            title: '全部.',
            image: './images/zu17.png'
        }
        res.data.data.album.unshift(albumAllAudio)
        this.albumArr = res.data.data.album
      })
    },
    toWePath(path) {
      this.$router.push({path:path,query:{}});
    },
    toAudioPlayer(y) {
      if (y.is_examine == 0 || y.is_examine == 1|| y.is_examine == 3){
        Toast('审核中和未通过审核的作品无法查看，请规范作品内容',2000)
        return
      }
      this.$router.push({path:'/AudioPlayer',query:{ id: y.id }});
    },
    onPagination() {
      let y = this.page
      y++
      this.page = y
      if(this.albumIndex == 0){
        this.getIndexList(this.page)
      }else{
        this.getAlbumVioceList(this.albumInfo.id,this.page)
      }
      
    },
    edit() {
      this.$router.push({path:'/release',query:{ id: this.voiceInfoAlone.id }});
    },
    toEditAlbum() {
      this.$router.push({path:'/albumDetail',query:{ id: this.albumInfo.id }});
    },
    deletec() {
      this.showPanecl = false
      Dialog.confirm({
        title: '提示',
        message: '是否删除',
      })
      .then(() => {
        // on confirm
        Toast.loading({
          message: '',
          forbidClick: true,
          duration: 0,
          className: 'cnavasToast'
        });
        const obj = {
          id: this.voiceInfoAlone.id,
          openid: window.localStorage.getItem('openid')
        }
        this.$aGet('api/voice/del',obj ).then((res) => {
          Toast.clear()
          Toast(res.data.msg)
          if (res.data.code == 0) {
          } else {
            setTimeout(()=>{
              this.loading = false
              this.finished = false
              this.page = 1
              this.voiceArr = []
              if(this.albumIndex == 0){
                this.getIndexList(1)
              }else{
                this.getAlbumVioceList(this.albumInfo.id,1)
              }
            },1100)
          }
        })
      })
      .catch(() => {
        // on cancel
      });
    },
    operate(value) {
      this.voiceInfoAlone = value

      this.showPanecl = true
    },
    timeStampConversions (v) {
        let date = new Date(v * 1000)
        const Y = date.getFullYear()
        const M = date.getMonth() + 1
        const D = date.getDate()
        const h = date.getHours()
        const m = date.getMinutes()
        const s = date.getSeconds()
        return `${Y}-${M}-${D}`
    },
    takeThePass(v) {
      Toast.loading({
        message: '',
        forbidClick: true,
        duration: 0
      });
      if(v == 1){
        this.$aGet('api/follow/qxFollow',{ follow_uid: this.othersUid} ).then((res) => {
          Toast.clear()
          if(res.data.code == 0){
            Toast(res.data.msg);
          }else{
            this.$set(this.mainListInfo,'is_follow',0)
            Toast('取消成功');
          }
          
        })
      }else{
        this.$aGet('api/follow/follow',{ follow_uid: this.othersUid} ).then((res) => {
          Toast.clear()
          if(res.data.code == 0){
            Toast(res.data.msg);
          }else{
            this.$set(this.mainListInfo,'is_follow',1)
            Toast('关注成功');
          }
          
        })
      }
    },
    setnav(i,k){
        this.albumIndex = k
        this.voiceArr = []
        this.finished = false;
        this.loading = true;
        this.page = 1
        if(k == 0){
          this.getIndexList(1)
        }else{
          this.albumInfo = i
          this.getAlbumVioceList(this.albumInfo.id,this.page)
        }   
        
        
    },
    operationStick(v) {
      console.log(v)
      this.$aGet('api/voice/top',{ type: v, id: this.voiceInfoAlone.id, } ).then((res) => {
        Toast(res.data.msg);
        if (res.data.msg == '置顶成功') {
          this.$set(this.voiceInfoAlone,'is_top',1)
        }else{
          this.$set(this.voiceInfoAlone,'is_top',0)
        }
        this.finished = false
        this.page = 1
        setTimeout(() => {
          this.voiceArr = []
          this.showPanecl = false
          if (this.albumIndex == 0) {
            
            this.getIndexList(1)
          } else {
            this.getAlbumVioceList(this.albumInfo.id,1)
          }
        }, 1000)
      })
    },
    getAlbumVioceList(albumId,page) {
      const obj = {
        album_id: albumId,
        page
      }
      this.$aGet('api/album/albumVoiceList',obj ).then((res) => {
        this.loading = false;
        if(res.data.data.voice.length != 0){
            this.finished = false;
            res.data.data.voice.forEach((v,l)=>{
                res.data.data.voice[l].addtime = this.timeStampConversions(res.data.data.voice[l].addtime)
            })
            this.voiceArr = this.voiceArr.length == 0?res.data.data.voice:[...this.voiceArr,...res.data.data.voice]
        }else{
            this.finished = true;
            this.voiceArr = this.voiceArr
        }
      })
    }
  },
}
</script>

<style scoped>
.mask_share23{
      width: 100%;
      height:100vh;
      background: rgba(0,0,0,.7);
      position: fixed;
      top: 0;
      left: 0;
      z-index: 99999;
  }
  .shareimg{
      position: absolute;
      top: 1.43rem;
      right: 1.07rem;
      width: 2.86rem;
  }
  .sharebtnxdd{
      color:#fff;
      position: absolute;
      top: 7rem;
      right: 1.07rem;
  }
.bmkuoce{
  position: absolute;
  left: 1.14rem;
  bottom: -2.2rem;
}
  .code_canvas{
    width: 7.14rem;
    height: 7.14rem;
    background: #ddd;
  }
  .name_canvas{
    width: 7.86rem;
    padding-left: .43rem;
    color: #666;
  }
  .h_n_m{
    margin-top: .8rem;
    padding-left: .71rem;
    display: flex;
    align-items: center;
  }
  .header_canvas{
    width: 2.14rem;
    height: 2.14rem;
    background: pink;
    border-radius: .2rem;
  }
  .title_opx{
    word-wrap:break-word;
    /* white-space: pre; */
    overflow: hidden;
    width:10.3rem;
    height: 2.9rem;
    padding-left: .51rem;
    font-size: 1.1rem;
    color: #000;
    font-weight: 500;
  }
  .img_userinfo_o{
    width: 6rem;
    height: 6rem;
    background: #ddd;
    border-radius: .43rem;
  }
  .img_userinfo{
    display: flex;
  }
  .main_cx{
    width: 100%;
    height: 16.24rem;
    padding: .71rem;
  }
  .top_canvasImg{
    height: 11.5rem;
    width: 18rem;
    background-size: cover;
    background-position: center;
  }
  .saveCarme {
    width: 14.64rem;
    /* height: 2.5rem; */
    border-radius: 17.5rem;
    color: #fff;
    background: #FE7C6E;
    font-size: 1rem;
    text-align: center;
    /* line-height: 2.5rem; */
    padding: .71rem 0;
    margin: .71rem auto 0;

  }
  .canvas_img{
    width: 18rem;
    height: 27.75rem;
    background: #fff;
  }
  .closecanvas{
    position: absolute;
    top: -2.71rem;
    right: 0px;
  }
  .centerMain{
    width: 18rem;
    height: 33.64rem;
    position: relative;
  }
   .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .flurImg{
    width: 100%;
    height: 26.79rem;
    filter: blur(2px);		
      -webkit-filter: blur(2px);  /* chrome, opera */
      -ms-filter: blur(2px);
      -moz-filter: blur(2px);
    position: absolute;
    left: 0;
    top: 0;
    transform: scale(1.1);
  }
  .zhidingclass{
    font-size: .71rem;
    display: inline-block;
    border: 1px solid red;
    color: red;
    position: absolute;
    right: .71rem;
    top: .71rem;
    padding: 0 .21rem;
  }
  .index{
    background: #f8f8f8;
    /* width: 1.36rem; */
  }
  
  .data_info{
    width: 10.71rem;
    height: 2.86rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 1.71rem;
  }
  .data_info2{
    position: absolute;
    bottom: -2.86rem;
    left: 1.04rem;
    margin-top:.71rem;
    font-size:.86rem;
    color:#fff;
    width:12.43rem;
    
    /* background: pink; */
  }
  .infobrif{
    font-size: .95rem;
    color: #fff;
    padding-top: .71rem;
    height: 2.57rem;
    overflow: hidden;
  }
  .username{
    font-size: 1.39rem;
    color: #fff;
    font-weight: 500;
    width: 13rem;
    padding-left: .71rem;
    margin-top:1rem;
  }
  .f1{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .f2{
    display: -webkit-box;
    word-break: break-all;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  .header{
    width: 4.17rem;
    height: 4.17rem;
    border: 2px solid #fff;
    border-radius: 50%;
  }
  .headerorname{
    display: flex;
    /* align-items: center; */
  }
  .top_i_m{
    padding: 1.07rem;
    position: relative;
  }
  .top_info{
    width: 100%;
    height: 26.79rem;
    background: #fff;
    color: #fff;
    position: relative;
    position: fixed;
    top: 0;
    left: 0;
  }
   .btn{
    width: 5.8rem;
    /* height: 1.79rem; */
    padding: 5px 0;
    text-align: center;
    /* line-height: 1.79rem; */
    background: rgba(255,255,255,.2);
    color: #fff;
    font-size: 1rem;
    border-radius: 3.57rem;
  }
  .mian{
        width: 100%;
        position: relative;
        min-height: 27.14rem;
        
        background: #fff;
        border-top-left-radius: 1.07rem;
        border-top-right-radius: 1.07rem;
        margin-top: 19rem;
    }
    .main_zj{
        padding: .89rem;
        padding-right: 0;
        padding-left: 0;
        /* height: 5rem; */
        width: 100%;
        overflow-x: scroll; 
        white-space:nowrap;
        /* padding-bottom: .36rem; */
        /* display: flex; */
    }
    .everyAlbum {
        width: 6.79rem;
        height: 3.29rem;
        border: 2px solid transparent;
        border-radius: 5px;
        list-style: none;
        display: inline-block;
        background-size: cover;
        background-position: center;
        overflow: hidden;
        position: relative;
        /* background: #ddd; */
    }
    .releaseImg{
      width: 4.61rem;
      height: 4.61rem;
      position: fixed;
      right: 1.07rem;
      bottom: 2rem;
      z-index: 10;
    }
    .everyAlbumText {
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 5.71rem;
        line-height: 3.29rem;
        padding-left: .5rem;
        color: #fff;
        font-size: .93rem;
        position: relative;
        height: 3.29rem;
    }
    .mask_everyAlbum{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.3);
    }
    .everyAlbum~.everyAlbum{
        margin-left: 1.13rem;
    }
    ::-webkit-scrollbar{
        display: none;
    }
    .main_list{
        width: 100%;
        padding: .71rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
    }
    .ceeex{
        padding: 1.07rem;
        padding-bottom: 0;
    }
    .ypimg{
        width: 6.21rem;
        height: 6.21rem;
        background: #ddd;
    }
    .f2{
        display: -webkit-box; 
        -webkit-line-clamp: 2; 
        -webkit-box-orient: vertical; 
        overflow: hidden;
    }
    .ypinfo{
        
        color: #000;
        padding-left:.71rem

    }
    .title{
        width: 11rem;height:3.93rem;line-height:1.9rem;font-size:1.14rem;
    }
    .bottom_info{
        display: flex;
        align-items: center;
        width: 11rem;
        justify-content: space-between;
        font-size: 13px;
        color: #bbb;
        padding-top: 1.07rem;
    }
    .content {
        padding: 16px 16px 160px;
    }
    .lloeididt{
        height: 3.29rem;
        display: flex;
        align-items: center;
        font-size: 1.07rem;
    }
    .albumActive{
        border-color: #FE7C6E;
    }
    .mask_share{
        width: 100%;
        height:100vh;
        background: rgba(0,0,0,.7);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99999;
    }
    .shareimg{
        position: absolute;
        top: 1.43rem;
        right: 1.07rem;
        width: 2.86rem;
    }
    .wefabux{
        color: #FE7C6E;
        font-size: .93rem;
        background: #fff;
        border-radius: 5px;
        width: 5.5rem;
        /* height: 1.86rem; */
        text-align: center;
        /* line-height: 1.86rem; */
        position: absolute;
        padding: 4px 0;
        right: 0;
        top: 0;
    }
    .sharebtnxdd{
        color:#fff;
        position: absolute;
        top: 7rem;
        right: 1.07rem;
        /* width: 2.86rem; */
    }
  .release{
      width: 7.14rem;
      height: 2.14rem;
      background: #fff;
      position: absolute;
      right: 0;
      top: 2.2rem;
      text-align: center;
      line-height: 2.14rem;
      border-top-left-radius: 3.57rem;
      border-bottom-left-radius: 3.57rem;
      color: #FE7C6E;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 100;
  }
  .mask_f{
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.6);
    left: 0;
    top: 0;
  }
  .albumcard{
    width: 100%;
    height: 4.29rem;
    padding: .71rem;

    /* padding-top: 0; */
    background: #f8f8f8;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue